import {useTranslation} from "react-i18next";
import React, {useMemo} from "react";
import {calcTeamLuck} from "../../../function";
import TeamLuckComponent from "../../TeamLuck/TeamLuckComponent";
import styled from "styled-components";

const AvgTierWrapper = styled.div`
  text-transform: capitalize;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 4px;
  font-weight: 400;
  color: ${props => props.theme.color.dark_200};
  font-size: 12px;
`;
const TeamLuck = ({myAiScore, avgAiScore}) => {
    const {i18n, t} = useTranslation();
    const teamLuckValue = useMemo(() => {
        try {
            const teamLuck = calcTeamLuck({avgAiScore, myAiScore});
            return teamLuck
        } catch (e) {
            console.log(e)
            return 0;
        }
    }, [avgAiScore, myAiScore])

    return (
        <AvgTierWrapper>
            <TeamLuckComponent teamLuckValue={teamLuckValue}/>
        </AvgTierWrapper>
    )
}

export default TeamLuck